module.exports = __webpack_public_path__ + "media/Polos.37394fad.mp4";